import TableSettings from './Table';
export default TableSettings;